import { createApolloClient } from "../../services/apolloClient";
import { InventoriesResponse, InventoryItem } from "./types";
import { parseCleaningTypes } from "../../utils/createNewOrderUtils";
import { INVENTORIES_QUERY } from "./queries";

const getErrorMessage = (error: unknown, fallback: string) => {
  if (!error || typeof error !== "object") {
    return fallback;
  }

  const graphQLErrors = (
    error as { graphQLErrors?: Array<{ message?: string }> }
  ).graphQLErrors;

  if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) {
    const firstMessage = graphQLErrors[0]?.message;
    if (firstMessage) {
      return firstMessage.replace(/^Error:\s*/i, "");
    }
  }

  if (error instanceof Error && error.message) {
    return error.message.replace(/^Error:\s*/i, "");
  }

  return fallback;
};

const client = createApolloClient(true);

export const inventoryService = {
  async fetchInventories(): Promise<InventoryItem[]> {
    try {
      const result = await client.query({
        query: INVENTORIES_QUERY,
        fetchPolicy: "no-cache",
      });

      const data = result.data as InventoriesResponse | undefined;

      if (!data?.inventories) {
        throw new Error("Failed to fetch inventory items");
      }

      return data.inventories.map((item) => ({
        ...item,
        cleaningTypes: parseCleaningTypes(item.cleaning_types),
      }));
    } catch (error) {
      throw new Error(
        getErrorMessage(error, "Failed to fetch inventory items"),
      );
    }
  },
};
